module.exports = __webpack_public_path__ + "static/media/github.blue.6cd8facf.png";